export default "__VITE_ASSET__CB21KZFq__"